import styled from 'styled-components';
import { darken } from 'polished';

export const Container = styled.aside`
  width: 410px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  padding: 5px;
  border-radius: ${({ theme }) => theme.metrics.radius};
  background-color: ${({ theme }) => darken(0.05, theme.colors.background)};

  @media (max-width: ${({ theme }) => theme.metrics.tablet_small}) {
    width: auto;
    min-width: 100%;
    max-height: calc(100vh - 80px);
  }
`;
